// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"list_wrapper__n2hIO","list":"list_list__Gu_PL","listItem":"list_listItem__950eN","listTitle":"list_listTitle__fVvfJ"};